module.exports = __webpack_public_path__ + "img/Specom-β.4f9803e6.png";